import { useEffect, useState } from "react";
import { toast } from "sonner";
import { API_ENDPOINTS } from "../utils/urls";
import api from "../utils/api";

interface Props {
  setShowForm: (value: boolean) => void;
  editData?: any;
}

const EditAddOn: React.FC<Props> = ({ setShowForm, editData }) => {
  const [inventoryList, setInventoryList] = useState([
    {
      id: "",
      name: "",
      price: "",
      stock: 0,
      sku: "",
    },
  ]);
  useEffect(() => {
    if (editData) {
      setInventoryList([{ ...editData }]); // load for editing
    }
  }, [editData]);

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.key === "Escape") setShowForm(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleSubmit = async () => {
    try {
      // Edit mode
      await api.put(
        `${API_ENDPOINTS.INVENTORY.UPDATE_ADDON_DATA}`,
        inventoryList[0]
      );
      toast.success("Item updated successfully!");

      setShowForm(false);
      setInventoryList([
        {
          id: "",
          name: "",
          price: "",
          stock: 0,
          sku: "",
        },
      ]);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("Failed to save item(s)");
      console.error(error);
    }
  };

  const handleInventoryInputChange = (
    e: any,
    invIndex: number,
    field: string
  ) => {
    const updated: any = [...inventoryList];
    updated[invIndex][field] = e.target.value;
    setInventoryList(updated);
  };

  return (
    <div className="mt-6">
      {inventoryList.map((item, i) => (
        <div key={i} className="mb-8 border p-4 rounded shadow-sm bg-gray-50">
          <div className="mb-2">
            <input
              type="text"
              placeholder="AddOn Name"
              value={item.name}
              onChange={(e) => handleInventoryInputChange(e, i, "name")}
              className="w-full border p-2 mb-2"
            />
            <input
              type="number"
              placeholder="Price"
              value={item.price}
              onChange={(e) => handleInventoryInputChange(e, i, "price")}
              className="w-full border p-2 mb-2"
            />
            <input
              type="number"
              placeholder="Stock"
              value={item.stock}
              onChange={(e) => handleInventoryInputChange(e, i, "stock")}
              className="w-full border p-2 mb-2"
            />
            <input
              type="text"
              placeholder="SKU"
              value={item.sku}
              onChange={(e) => handleInventoryInputChange(e, i, "sku")}
              className="w-full border p-2 mb-2"
            />
            {inventoryList.length > 1 && (
              <button
                className="text-red-500 text-sm"
                onClick={() => {
                  const updated = [...inventoryList];
                  updated.splice(i, 1);
                  setInventoryList(updated);
                }}
              >
                Remove This Item
              </button>
            )}
          </div>
        </div>
      ))}

      <button
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-6 py-2 rounded"
      >
        {editData ? "Update AddOn" : "Save AddOn"}
      </button>
    </div>
  );
};

export default EditAddOn;
